
import { LOGIN_USER_SUCCESS, LOGOUT_USER, UPDATE_USER_DATA, INIT_USER_FROM_COOKIES } from './constants';

const INIT_STATE = {
    user: null,
};

const Auth = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER_SUCCESS:
            return { ...state, user: action.payload.data.user };
        case LOGOUT_USER:
            return { ...state, user: null };
        case UPDATE_USER_DATA:
            return { ...state, user: action.payload };
        case INIT_USER_FROM_COOKIES:
            return { ...state, user: action.payload };
        default:
            return { ...state };
    }
};

export default Auth;
